import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Upload } from 'antd';
import { workOrderChatUploadCustomRequest } from '../../thunks/file_thunks';

const ChatUploader = (props) => {
	const [loading, setLoading] = useState<boolean>(false);
	const { uploaderType, customUploadRequest } = props;
	const UploadComponent = useMemo(() => {
		if (uploaderType === 'dragger') {
			return Upload.Dragger;
		}
		return Upload;
	}, [uploaderType]);
	return (
		<div>
			<UploadComponent
				{...props}
				disabled={loading}
				customRequest={({ file, onError, onSuccess, onProgress }) => {
					setLoading(true);
					const uploadFn = customUploadRequest || workOrderChatUploadCustomRequest;
					uploadFn({
						userType: props.userType,
						workOrderId: props.id,
						file: file,
						onError: (error) => {
							setLoading(false);
							onError(error);
						},
						onSuccess: (response) => {
							setLoading(false);
							onSuccess(response);
						},
						onProgress: onProgress,
						source: 'ChatUploader',
					});
				}}
			>
				<div>{props.children}</div>
			</UploadComponent>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		userType: state.session.userType,
	};
};

export default connect(mapStateToProps)(ChatUploader);
